module.exports = __webpack_public_path__ + "img/sticky-note.78c4b967.svg";